import { render } from "./periodSelected.vue?vue&type=template&id=2729244e"
import script from "./periodSelected.vue?vue&type=script&lang=js"
export * from "./periodSelected.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__